export enum MatButtonType {
  RAISED = 'raised',
  STROKED = 'stroked',
  FLAT = 'flat',
  MENU = 'menu',
  FAB = 'fab',
  MINI_FAB = 'mini-fab',
  EXTENDED_FAB = 'extended-fab',
}

export enum MatButtonColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ACCENT = 'accent',
  WARN = 'warn',
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
}
